export default __webpack_public_path__ + "static/media/html.ae829b8c.png";